import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { tap } from 'rxjs';

@Component({
    selector: 'app-shared-device-control',
    templateUrl: './shared-device-control.component.html',
    styleUrls: ['./shared-device-control.component.scss'],
    standalone: false
})
export class SharedDeviceControlComponent implements OnInit {
  @Input() passphraseControl: FormControl | null = new FormControl();
  @Input() submitted = false;
  @Input() errorsList: Record<string, any> = {};
  @Input() hintText = '';

  @Output() useSharedDeviceChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() openSharedDeviceInfo: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() changedPassphraseValue: EventEmitter<string> = new EventEmitter<string>();

  useSharedDeviceControl = new FormControl(false);

  protected get isShowPassphraseControl(): boolean {
    return (
      !!this.passphraseControl &&
      !!this.useSharedDeviceControl.value &&
      this.useSharedDeviceControl.enabled
    );
  }

  constructor(private readonly destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.useSharedDeviceControl.setValue(!!this.passphraseControl?.value);

    if (this.passphraseControl?.disabled) {
      this.useSharedDeviceControl.disable();
    }

    // TODO: use when user can edit passphrase
    // if (this.passphraseControl && !!this.passphraseControl.value) {
    //   this.passphraseControl.enable();
    // }

    this.initUseSharedDeviceChanges();
  }

  onChangedPassphrase(value: string): void {
    this.changedPassphraseValue.emit(value);
  }

  onOpenSharedDeviceInfo() {
    this.openSharedDeviceInfo.emit(true);
  }

  private initUseSharedDeviceChanges() {
    this.useSharedDeviceControl.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((useSharedDevice) => {
          this.useSharedDeviceChanged.emit(useSharedDevice ?? false);
        })
      )
      .subscribe();
  }
}
